import { forwardRef } from 'react'
import { clsx } from 'clsx'
import styles from './Input.module.css'

/**
 * @typedef {Object} InputProps
 * @property {string} type
 * @property {string} placeholder
 * @property {boolean} disabled
 * @property {string} className
 * @property {Function} onChange
 * @property {string} value
 * @property {string} name
 * @property {string} id
 * @property {boolean} required
 * @property {boolean} error
 */

/**
 * @param {InputProps} props
 */
const Input = forwardRef(
  ({ type = 'text', className, error, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={clsx(styles.input, error && styles.error, className)}
        {...props}
      />
    )
  }
)

Input.displayName = 'Input'

export default Input
